import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { VehiclesDetail } from '../../../components/Vehicles/VehiclesDetail';

export const VehiclesDetailsPage = () => {
  return (
    <DashboardLayout title={'Unidades'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <VehiclesDetail />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
